<input
  [id]="id"
  (blur)="blur.emit()"
  [disabled]="disabled"
  [(ngModel)]="currentValue"
  (ngModelChange)="onInputChange()"
  [class.invalid]="!validNumber && currentValue"
  class="telephone-input form-control"
/>
